<template>
    <div class="form_flex_wrap">
        <div v-if="isLoading" class="loading_bg round_none transparent" style="z-index: 999">
            <div class="loading_wrap">
                <div class="loading_obj">
                    <svg class="spinner" width="60px" height="60px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                        <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
                    </svg>
                </div>
            </div>
        </div>
        <div class="form_flex_title">
            <span class="title">{{ $t('reservation_settings.section_appointment_display_method.title') }}</span>
            <span class="info mgl_auto">{{ $t('reservation_settings.section_appointment_display_method.sub_title') }}</span>
        </div>
        <div class="form_flex_cont rsv_item_set">
            <ul class="form_list">
                <li class="title">{{ $t('reservation_settings.section_appointment_display_method.label_select_items_to_display') }}</li>
                <li class="cont">
                    <label class="check_wrap" v-for="cell in filteredCells" :key="cell.key">
                        <input type="checkbox" :checked="isChecked(cell.key)" @change="updateValue(cell.key)" />
                        <span class="checkmark"></span>
                        {{ cell.title }}
                    </label>
                </li>
                <li class="rsv_item_preview rsv_item">
                    <div class="title">{{ $t('reservation_settings.section_appointment_display_method.label_preview') }}</div>
                    <div class="rsv_item_box">
                        <span class="ad_ic">
                            <img src="../../../../../../../../assets/img/ic_afterdoc_symbol_saas.png" alt="" />
                        </span>
                        <span class="name">{{ $t('reservation_settings.section_appointment_display_method.label_sample_user_name') }}</span>
                        <span class="chartnum" v-if="isChecked('chartNumber') && isUsingChartNumber"> ({{ $t('reservation_settings.section_appointment_display_method.label_patient_id') }})</span>
                        <br />
                        <span class="gen" v-if="isChecked('gender')">{{ $t('reservation_settings.section_appointment_display_method.label_gender') }}</span>
                        <span class="birth" v-if="isChecked('birth')">{{ $t('reservation_settings.section_appointment_display_method.label_dob') }}</span>
                        <span class="patient_type" v-if="isChecked('isFirstVisit') && isUsingFirstVisitStartDate">{{ $t('reservation_settings.section_appointment_display_method.label_class') }}</span>
                        <span class="user_tag" v-if="isChecked('userTagIDs') && isUsingUserTag">{{ $t('reservation_settings.section_appointment_display_method.label_user_tag') }}</span>
                        <br />
                        <span class="program" v-if="isChecked('programID')">{{ $t('reservation_settings.section_appointment_display_method.label_program') }}</span>
                        <span class="rsv_memo" v-if="isChecked('note')">{{ $t('reservation_settings.section_appointment_display_method.label_appt_memo') }}</span>
                        <span class="patient_memo" v-if="isChecked('reservationUserNote')">{{ $t('reservation_settings.section_appointment_display_method.label_medical_history') }}</span>
                    </div>
                </li>
            </ul>
        </div>
        <div class="btn_wrap">
            <span class="editor_info mgr_auto">{{ modifiedAt }} / {{ modifier }}</span>
            <button class="btn btn_l btn_blue mgl_auto" @click="reqeustUpdateReservationSetting">
                {{ $t('common.save') }}
            </button>
        </div>
    </div>
</template>

<script>
const moment = require('@/util/MPMoment')
import { useQueryClient } from '@tanstack/vue-query'
import { v2ReservationSettingFindOneQueryOptions } from '@/composables/queries/v2reservationsetting/use-v2-reservationsetting-find-one-query'
import { useV2ReservationSettingUpdateMutation } from '@/composables/queries/v2reservationsetting/use-v2-reservationsetting-update-mutation'

export default {
    setup() {
        const queryClient = useQueryClient()
        const { mutateAsync: updateReservationSetting } = useV2ReservationSettingUpdateMutation()
        return { queryClient, updateReservationSetting }
    },
    props: {},
    data() {
        return {
            isLoading: false,
            result: undefined,

            cells: [
                { title: this.$t('reservation_settings.section_appointment_display_method.label_patient_id'), key: 'chartNumber' },
                { title: this.$t('reservation_settings.section_appointment_display_method.label_gender'), key: 'gender' },
                { title: this.$t('reservation_settings.section_appointment_display_method.label_dob'), key: 'birth' },
                { title: this.$t('reservation_settings.section_appointment_display_method.label_class'), key: 'isFirstVisit' },
                { title: this.$t('reservation_settings.section_appointment_display_method.label_user_tag'), key: 'userTagIDs' },
                { title: this.$t('reservation_settings.section_appointment_display_method.label_program'), key: 'programID' },
                { title: this.$t('reservation_settings.section_appointment_display_method.label_appt_memo'), key: 'note' },
                { title: this.$t('reservation_settings.section_appointment_display_method.label_medical_history'), key: 'reservationUserNote' }
            ]
        }
    },
    watch: {},
    computed: {
        cellInfo: function () {
            return this.result?.cellInfo ?? []
        },
        isUsingChartNumber: function () {
            return this.servicesetting?.setting?.usingChartNumber ?? false
        },
        isUsingFirstVisitStartDate: function () {
            return this.servicesetting?.setting?.usingFirstVisitStartDate ?? false
        },
        isUsingUserTag: function () {
            return this.servicesetting?.setting?.usingUserTag ?? false
        },
        filteredCells: function () {
            let filteredCells = []
            filteredCells = this.cells.filter(
                (cell) =>
                    !(this.isUsingChartNumber == false && cell.key == 'chartNumber') &&
                    !(this.isUsingFirstVisitStartDate == false && cell.key == 'isFirstVisit') &&
                    !(this.isUsingUserTag == false && cell.key == 'userTagIDs')
            )
            return filteredCells
        },
        modifiedAt: function () {
            if (this.result?.cellInfoModifiedAt == undefined) {
                return '-'
            } else {
                return moment(this.result?.cellInfoModifiedAt).format(this.$t('common.date_format_YYYY_MM_DD_HH_mm'))
            }
        },
        modifier: function () {
            if (this.result?.cellInfoModifierID == undefined) {
                return '-'
            } else {
                if (this.result.cellInfoModifierID.type >= 3000) {
                    return this.$t('reservation_settings.section_appointment_display_method.label_modified_afterdoc')
                } else {
                    return `${this.result.cellInfoModifierID.realName} ${this.$t('reservation_settings.section_appointment_display_method.label_modified')}`
                }
            }
        }
    },
    mounted() {
        this.reqeustFetchReservationSetting()
    },
    methods: {
        // 체크여부 확인
        isChecked(key) {
            return this.cellInfo.includes(key)
        },
        // 선택된 데이터 변경
        updateValue(key) {
            if (this.isChecked(key)) {
                let index = this.cellInfo.findIndex((c) => c == key)
                this.cellInfo.splice(index, 1)
            } else {
                this.cellInfo.push(key)
            }
        },
        // 예약설정 조회
        async reqeustFetchReservationSetting() {
            try {
                this.isLoading = true
                let param = {
                    hospitalID: this.hospital.selectedHospital._id
                }
                // 봉투 에러(code != 0)는 ApiError로 throw — 아래 catch에서 로그 (기존 동작 동일)
                this.result = await this.queryClient.fetchQuery(v2ReservationSettingFindOneQueryOptions(param))
            } catch (err) {
                console.log('reservation setting find error from display method component ', err)
            } finally {
                this.isLoading = false
            }
        },
        // 예약설정 변경
        async reqeustUpdateReservationSetting() {
            try {
                if (this.isLoading) {
                    return
                }
                this.isLoading = true

                let data = {
                    _id: this.result._id,
                    hospitalID: this.hospital.selectedHospital._id,
                    cellInfo: this.cellInfo
                }

                // 봉투 에러(code != 0)는 ApiError로 throw — 아래 catch에서 로그 (기존 동작 동일)
                this.result = await this.updateReservationSetting(data)
                this.setToast({
                    isShow: true,
                    text: this.$t('common.label_save_success')
                })
            } catch (err) {
                console.log('reservation setting update error from display method component ', err)
            } finally {
                this.isLoading = false
            }
        }
    }
}
</script>
